import classNames from 'classnames';
import { Star } from 'components/gruenland/icons/Star';

interface Props {
  rating: number;
  variant?: 'sm' | 'lg';
  color?: 'white' | 'black';
  className?: string;
}

const MAX_WIDTH: Record<NonNullable<Props['variant']>, number> = {
  sm: 16,
  lg: 24,
};

const StarRating: React.FC<Props> = ({ rating, variant = 'lg', color = 'black', className }) => (
  <div className={classNames('relative', className)}>
    <div className="flex gap-2">
      {Array(5)
        .fill(0)
        .map((_, i) => (
          <Star
            key={i}
            className={classNames('opacity-30', {
              'size-6': variant === 'lg',
              'size-4': variant === 'sm',
              'fill-white': color === 'white',
            })}
          />
        ))}
    </div>
    <div className="absolute inset-0 flex gap-2">
      {Array(Math.ceil(rating || 0))
        .fill(0)
        .map((_, i) => (
          <div
            key={i}
            className={classNames('overflow-hidden')}
            style={{ width: Math.round(MAX_WIDTH[variant] * Math.min(1, rating - i)) }}
          >
            <Star
              className={classNames({
                'size-6': variant === 'lg',
                'size-4': variant === 'sm',
                'fill-white': color === 'white',
              })}
            />
          </div>
        ))}
    </div>
  </div>
);

export default StarRating;
